import React, { useState, useEffect } from "react";
import { User } from "../../../../api";
import { Loader, Dropdown } from "semantic-ui-react";
import { map, size, filter } from "lodash";
import { useAuth } from "../../../../hooks";
import { UserItem } from "../UserItem/UserItem";
import { useTranslation } from "react-i18next";

const usercontroller = new User();

export function ListUsers(props) {
  const { userActive, reload, onReload } = props;
  const [users, setUsers] = useState(null);
  const [selectedRole, setSelectedRole] = useState("admin");
  const { accessToken } = useAuth();
  const { t } = useTranslation("users");

  const roleOptions = [
    { key: "all", value: "all", text: t("list.allRoles") },
    { key: "admin", value: "admin", text: t("form.roleAdmin") },
    { key: "user", value: "user", text: t("form.roleUser") },
    { key: "client", value: "client", text: t("form.roleClient") },
    { key: "partner", value: "partner", text: t("form.rolePartner") },
    { key: "teacher", value: "teacher", text: t("form.roleTeacher") },
    { key: "student", value: "student", text: t("form.roleStudent") },
    {
      key: "institution",
      value: "institution",
      text: t("form.roleInstitution"),
    },
  ];

  useEffect(() => {
    (async () => {
      try {
        setUsers(null);
        const response = await usercontroller.getUsers(accessToken, userActive);
        if (response.users && response.users.length > 0) {
          setUsers(response.users);
        } else {
          setUsers([]);
        }
      } catch (error) {
        console.error(error);
      }
    })();
  }, [userActive, reload, accessToken]);

  const handleRoleChange = (_, { value }) => {
    setSelectedRole(value);
  };

  const filteredUsers =
    selectedRole === "all"
      ? users
      : filter(users, (user) => user.role === selectedRole);

  if (!users) {
    return <Loader active inline="centered" />;
  }

  return (
    <>
      {/* Dropdown para seleccionar el rol */}
      <Dropdown
        placeholder={t("list.roleFilterPlaceholder")}
        fluid
        selection
        options={roleOptions}
        onChange={handleRoleChange}
        value={selectedRole}
        style={{ marginBottom: "1em" }}
      />

      {/* Mostrar mensaje si no hay usuarios para el rol seleccionado */}
      {size(filteredUsers) === 0 ? (
        <p>{t("list.noUsersForRole")}</p>
      ) : (
        map(filteredUsers, (user) => (
          <UserItem key={user._id} user={user} onReload={onReload} />
        ))
      )}
    </>
  );
}
